<template>
  <div id="cardGroupMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月车管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡分组管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            navigationMap[cardGroupActiveName]
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组名称::">
          <el-input placeholder="请输入分组名称"
                    v-model="fGroupNameQuery"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardGroupQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addCardGroup"
                     v-if="is_edit">新增分组</el-button>
          <el-button type="primary"
                     size="small"
                     @click="syncAllCardGroup"
                     v-if="is_syn">批量下发</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="cardGroupActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="分组列表"
                     name="cardGroupList">
          <el-row>
            <el-table :data="cardGroupList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="170"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fGroupTypeName"
                               label="分组类型">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fAmountName"
                               align="right"
                               label="每月续费金额(元)">
              </el-table-column>
              <el-table-column prop="time"
                               label="进出起始时间">
              </el-table-column>
              <el-table-column fixed="right"
                               align="left"
                               label="操作"
                               width="400">
                <template slot-scope="scope">
                  <el-button @click="viewCardGroup(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCardGroup(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCardGroupClient(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="scope.row.fCustTypeID == '0' && is_syn"
                             @click="synCardGroup(scope.$index, scope.row, false)">上传</el-button>
                  <el-button size="mini"
                             v-if="is_set"
                             @click="showBatchBinds(scope.row)"
                             type="info">权限设置</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synCardGroupList">
          <el-row>
            <el-table :data="synCardGroupList"
                      border
                      :row-class-name="tableRowClassName"
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fGroupTypeName"
                               label="分组类型">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               label="分组名称">
              </el-table-column>
              <el-table-column prop="fAmountName"
                               align="right"
                               label="每月续费金额(元)">
              </el-table-column>
              <el-table-column prop="time"
                               label="进出起始时间">
              </el-table-column>
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="400">
                <template slot-scope="scope">
                  <el-button @click="viewCardGroup(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCardGroup(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCardGroupClient(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <!-- <el-button size="mini"
                             v-if="is_set"
                             @click="showBatchBinds(scope.row)"
                             type="info">权限设置</el-button> -->
                  <el-button size="mini"
                             type="info"
                             @click="synCardGroup(scope.$index, scope.row, true)"
                             v-if="is_syn">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="myCardGroupEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="cardGroupEditOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="30%">
        <el-form :model="curRowInfo"
                 class="cardGroupForm"
                 label-width="190px"
                 :rules="rules"
                 ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="客户名称::"
                            prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit || curRowInfo.op == 'edit'"
                           class="myCardGroupInput"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="分组名称::"
                            prop="fGroupName">
                <el-input v-model="curRowInfo.fGroupName"
                          placeholder="请输入分组名称"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardGroupInput"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="分组区域::"
                            prop="fAreaCustID">
                <el-select v-model="curRowInfo.fAreaCustID"
                           :clearable="true"
                           :disabled="!curRowInfo.isEdit"
                           placeholder="请选择所属客户">
                  <el-option v-for="item in fAreaCustList"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="分组分类::"
                            prop="fGroupType">
                <el-select v-model="curRowInfo.fGroupType"
                           :disabled="!curRowInfo.isEdit"
                           placeholder="请选择分类">
                  <el-option v-for="item in cardGroupTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="包月车每月续费金额(元)::"
                            prop="fAmount">
                <el-input v-model="curRowInfo.fAmount"
                          placeholder="请输入金额"
                          style="width:130px"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardGroupInput"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="续费月数::"
                            prop="fMonths">
                <el-input v-model="curRowInfo.fMonths"
                          placeholder="请输入续费月数"
                          style="width:130px"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardGroupInput"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="进场起始时间::"
                            prop="StartTime">
                <el-select v-model="curRowInfo.StartTime"
                           filterable
                           clearable
                           placeholder="请选择时间段"
                           :disabled="!curRowInfo.isEdit"
                           class="myCardGroupInput"
                           style="width:130px">
                  <el-option v-for="item in timeRange"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
                <span>至</span>
                <el-select v-model="curRowInfo.EndTime"
                           filterable
                           clearable
                           placeholder="请选择时间段"
                           :disabled="!curRowInfo.isEdit"
                           class="myCardGroupInput"
                           style="width:130px">
                  <el-option v-for="item in timeRange"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
                    <el-form-item label="新建包月车默认有效时间(天)::"
                            prop="fNewDefDays">
                <el-input v-model="curRowInfo.fNewDefDays"
                          placeholder="请输入有效时间(天）"
                          :disabled="!curRowInfo.isEdit"
                          ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="超出车位数处理方式::"
                            prop="fCardGroupCarPortType">
                <el-select v-model="curRowInfo.fCardGroupCarPortType"
                           :disabled="!curRowInfo.isEdit"
                           filterable
                           clearable
                           placeholder="请选择分类">
                  <el-option v-for="item in cardGroupCarPortTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="is_fDelIfInv">
            <el-col :span="24">
              <el-form-item label=""
                          prop="fDelIfInv">
                  <el-checkbox v-model="curRowInfo.fDelIfInv"
                               :disabled="!curRowInfo.isEdit">本分组包月车失效后自动删除包月车记录</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label=""
                          prop="fChkAskIn">
                  <el-checkbox v-model="curRowInfo.fChkAskIn"
                               :disabled="!curRowInfo.isEdit">本分组车辆进场需要询问开闸</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="分组播报语音::"
                            prop="fCardPlayVoc" style="margin-bottom:0px">
                <el-input v-model="curRowInfo.fCardPlayVoc"
                          placeholder="请输入播报语音"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardGroupInput"></el-input>
              </el-form-item>
                <el-alert title="本分组的月卡车辆只能在指定时间内进停车场"
                        type="error"
                        :closable="false"
                        description="分组播报语音填写为[p1]则不播报">
              </el-alert>
            </el-col>
          </el-row>
            <el-row>
            <el-col :span="24">
              <el-form-item label="分组总车位::"
                            prop="fParkPort" style="margin-top:10px;margin-bottom:0px">
                <el-input v-model="curRowInfo.fParkPort"
                          placeholder="请输入分组总车位"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardGroupInput"></el-input>
              </el-form-item>
                <el-alert title="总车位为0时不限制上限"
                        type="error"
                        :closable="false"
                        description="总车位大于0时，超过总数后以临时车身份入场">
              </el-alert>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="curRowInfo.isEdit">{{ save_msg }}</el-button>
          <el-button @click="cardGroupEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="批量下发"
                 :visible.sync="synDataVisible"
                 width="450px"
                 v-dialogDrag>
        <el-form label-width="100px"
                 :model="syncData"
                 :rules="synRules"
                 ref="ruleForm"
                 style="margin-top:20px">
          <el-form-item label="选择客户::"
                        prop="fCustID">
            <el-select v-model="syncData.fCustID"
                       filterable
                       style="width:250px"
                       placeholder="请选择客户">
              <el-option v-for="item in batchCusts"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="syncAllOk('ruleForm')">确定</el-button>
          <el-button @click="synDataVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="batchBindsTitle"
                 :visible.sync="batchBindsVisible"
                 width="50%"
                 v-dialogDrag>
        <el-row>
          <el-col style="padding:5px 0px 5px 0px">
            <el-checkbox v-model="batchBindsData.isClear">清空原始权限</el-checkbox>
          </el-col>
          <el-col>
            <el-tabs type="border-card">
              <el-tab-pane label="绑定场库">
                <el-table :data="batchBindsData.bindParkData"
                          height="250"
                          border
                          style="width: 100%">
                  <el-table-column prop="fParkName"
                                   label="绑定停车场">
                  </el-table-column>
                  <el-table-column prop="fPlaceNums"
                                   label="车位数量">
                  </el-table-column>
                  <el-table-column fixed="right"
                                   align="center"
                                   label="操作"
                                   width="100">
                    <template slot-scope="scope">
                      <el-button size="mini"
                                 type="danger"
                                 @click="deleteBindPark(scope.$index, scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-form :inline="true"
                         :rules="batchBindRules"
                         ref="batchForm"
                         :model="batchBindsData">
                  <el-row>
                    <el-col style="text-align:center;margin-top:25px;">
                      <el-form-item label="场库名称::"
                                    prop="fParkID">
                        <el-select v-model="batchBindsData.fParkID"
                                   placeholder="请选择场库">
                          <el-option v-for="item in batchBindsData.fParkList"
                                     :key="item.fParkID"
                                     :label="item.fParkName"
                                     :value="item.fParkID">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="车位数量::"
                                    prop="fPlaceNums">
                        <el-input v-model="batchBindsData.fPlaceNums"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="success"
                                   size="small"
                                   @click="addBindPark('batchForm')">增加</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="绑定进出通道">
                <!-- <el-row style="padding-bottom: 10px;padding-top: 10px">
                  <el-col :span="10">
                    <el-input placeholder="请输入通道名称"
                              v-model="batchBindsData.bindChannelName"
                              class="input-with-select">
                      <el-button slot="append"
                                 icon="el-icon-search"
                                 @click="bindParkQuery"></el-button>
                    </el-input>
                  </el-col>
                  <el-col :span="4">&nbsp;</el-col>
                  <el-col :span="10">
                    <el-input placeholder="请输入通道名称"
                              v-model="batchBindsData.unbindChannelName"
                              class="input-with-select">
                      <el-button slot="append"
                                 icon="el-icon-search"
                                 @click="unbindParkQuery"></el-button>
                    </el-input>
                  </el-col>
                </el-row> -->
                <el-row>
                  <el-col :span="10">
                    <el-table ref="bind"
                              :data="batchBindsData.bindChannelList"
                              border
                              style="width: 100%;height: 371px"
                              height="400"
                              @current-change="bindChnlChange"
                              highlight-current-row>
                      <el-table-column prop="fParkChnlName"
                                       label="绑定停车场通道">
                      </el-table-column>
                    </el-table>
                  </el-col>
                  <el-col :span="4"
                          style="text-align: center;">
                    <el-row style="padding-top: 120px">
                      <el-col :span="24">
                        <el-button type="primary"
                                   icon="el-icon-caret-left"
                                   style="width: 100px"
                                   @click="leftChnlBtnClick"></el-button>
                      </el-col>
                    </el-row>
                    <el-row style="padding-top: 20px">
                      <el-col :span="24">
                        <el-button type="primary"
                                   icon="el-icon-caret-right"
                                   style="width: 100px"
                                   @click="rightChnlBtnClick"></el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="10">
                    <el-table ref="unBind"
                              :data="batchBindsData.unBindChannelList"
                              border
                              style="width: 100%;height: 371px"
                              height="400"
                              @current-change="unbindChnlChange"
                              highlight-current-row>
                      <el-table-column prop="fParkChnlName"
                                       label="可选停车场通道">
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     :loading="batchSaveLoading"
                     @click="batchSave">{{ batchSaveTitle }}</el-button>
          <el-button @click="batchBindsVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as park from '../../api/park'
import * as card from '../../api/card'
export default {
  name: 'cardGroupMain',
  data () {
    var validateNum = (rule, value, callback) => {
      if (value) {
        if (!/^\+?[1-9]\d*$/.test(value)) {
          callback(new Error('请输入正确的车位数'))
        }
      }
      callback()
    }
    var validateMoney = (rule, value, callback) => {
      if (value) {
        if (!/^\d+$/.test(value)) {
          callback(new Error('请输入正确的金额数'))
        }
      }
      callback()
    }
    var validateMonth = (rule, value, callback) => {
      if (value) {
        if (!/^\+?[0-9]\d*$/.test(value)) {
          callback(new Error('请输入正确的月数'))
        }
      }
      callback()
    }
    return {
      loading: false,
      is_edit: false,
      is_fDelIfInv: false,
      is_del: false,
      is_syn: false,
      is_set: false,
      synDataVisible: false,
      batchBindsVisible: false,
      save_loading: false,
      save_msg: '保存',
      batchBindsTitle: '',
      batchSaveTitle: '确定',
      batchSaveLoading: false,
      fAreaCustList: [],
      batchBindsData: {
        fCustID: '',
        fGroupID: '',
        fCustTypeID: '',
        bindChannelList: [],
        unBindChannelList: [],
        rightRow: '',
        leftRow: '',
        isClear: true,
        bindParkData: [],
        fParkList: [],
        fParkID: '',
        fPlaceNums: ''
      },
      navigationMap: {
        cardGroupList: '分组列表',
        synCardGroupList: '待同步'
      },
      timeRange: [],
      cardGroupEditOrDetailVisible: false,
      cardGroupTypeListDefaultValue: '',
      curRowInfo: {
        fBigRowID: '',
        fCustID: '',
        fCustNo: '',
        fGroupID: '',
        fGroupType: '',
        fCardGroupCarPortType: '',
        fAmount: '',
        fMonths: '',
        fGroupName: '',
        StartTime: '',
        EndTime: '',
        fAreaCustID: '',
        isEdit: false,
        fCustTypeID: '',
        fCardPlayVoc: '',
        fNewDefDays: '',
        fParkPort: '',
        fDelIfInv: '',
        fChkAskIn: ''
      },
      cardGroupCarPortTypeList: [{ value: '以临时车身份入场', label: '以临时车身份入场' }, { value: '禁止入场', label: '禁止入场' }],
      detailTitle: '',
      cardGroupList: [],
      cardGroupTypeList: [],
      synCardGroupList: [],
      cardGroupActiveName: 'cardGroupList',
      fGroupNameQuery: '',
      selCustID: '',
      choiceCusts: [],
      batchCusts: [],
      tableHeight: 0,
      pageSize: 20,
      pageNo: 1,
      total: 0,
      syncData: {
        fCustID: ''
      },
      batchBindRules: {
        fParkID: [{ required: true, message: '请选择场库', trigger: 'change' }],
        fPlaceNums: [
          { required: true, message: '请填写车位数', trigger: 'blur' },
          { validator: validateNum, trigger: 'blur' }
        ]
      },
      synRules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }]
      },
      rules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }],
        fAmount: [{ validator: validateMoney, trigger: 'blur' }],
        fMonths: [{ validator: validateMonth, trigger: 'blur' }],
        fGroupName: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'curRowInfo.fCustID' (value) {
      this.curRowInfo.fAreaCustID = ''
      this.fAreaCustList = this.choiceCusts.filter(r => r.fCustID === value)
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup',
      'getCardGroupByQuery',
      'saveCardGroup',
      'deleteCardGroup',
      'synCardGroupById',
      'getCurrentUserPers'
    ]),
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    cardGroupQuery () {
      this.initData()
    },
    bindChnlChange (row) {
      this.leftRow = row
    },
    unbindChnlChange (row) {
      this.rightRow = row
    },
    leftChnlBtnClick () {
      if (this.rightRow) {
        this.batchBindsData.bindChannelList.push(this.rightRow)
        for (
          let index = 0;
          index < this.batchBindsData.unBindChannelList.length;
          index++
        ) {
          if (this.batchBindsData.unBindChannelList[index] === this.rightRow) {
            this.batchBindsData.unBindChannelList.splice(index, 1)
            break
          }
        }
      }
    },
    rightChnlBtnClick () {
      if (this.leftRow) {
        this.batchBindsData.unBindChannelList.push(this.leftRow)
        for (
          let index = 0;
          index < this.batchBindsData.bindChannelList.length;
          index++
        ) {
          if (this.batchBindsData.bindChannelList[index] === this.leftRow) {
            this.batchBindsData.bindChannelList.splice(index, 1)
            break
          }
        }
      }
    },
    batchSave () {
      this.$refs['batchForm'].validate(valid => {
        if (valid) {
          this.batchSaveLoading = true
          this.batchSaveTitle = '保存中…'
          card
            .batchBindCard({
              fCustID: this.batchBindsData.fCustID,
              fCustTypeID: this.batchBindsData.fCustTypeID,
              fGroupID: this.batchBindsData.fGroupID,
              bindChannelList: this.batchBindsData.bindChannelList,
              bindParkData: this.batchBindsData.bindParkData,
              isClear: this.batchBindsData.isClear
            })
            .then(res => {
              this.batchSaveLoading = false
              this.batchSaveTitle = '确定'
              if (res && res.data) {
                var data = res.data
                if (data.IsOk) {
                  if (this.batchBindsData.fCustTypeID === '0') {
                    this.$message.success('提示：设置成功，请到【月卡管理-待同步】下发')
                  } else {
                    this.$message.success('提示：设置成功')
                  }
                  this.batchBindsVisible = false
                } else {
                  this.$message.error('提示：批量下发权限失败')
                }
              }
            })
        }
      })
    },
    showBatchBinds (row) {
      this.batchBindsTitle = '【' + row.fGroupName + '】分组权限批量下发'
      this.batchBindsVisible = true
      this.batchBindsData = {
        fCustID: row.fCustID,
        fGroupID: row.fGroupID,
        bindChannelList: [],
        unBindChannelList: [],
        isClear: true,
        bindParkData: [],
        fParkList: [],
        fParkID: '',
        fPlaceNums: '',
        fCustTypeID: row.fCustTypeID
      }
      setTimeout(() => {
        if (this.$refs['batchForm']) {
          this.$refs['batchForm'].clearValidate()
        }
      }, 50)
      park.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.batchBindsData.fParkList = data.Data || []
            if (this.batchBindsData.fParkList.length > 0) {
              this.batchBindsData.fParkList.splice(0, 0, {
                fParkID: '0',
                fParkName: '全部'
              })
              this.batchBindsData.fParkID = this.batchBindsData.fParkList[0].fParkID
            }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
      park.getChannelList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var parkData = data.Data || []
            parkData.forEach(e => {
              e.fParkChnlName = '【' + e.fParkName + '】' + e.fChnlName
            })
            this.batchBindsData.unBindChannelList = parkData
          } else {
            this.$message.error('提示：加载场库通道列表失败')
          }
        }
      })
    },
    deleteBindPark (index, row) {
      this.$confirm(
        '删除【' + row.fParkName + '】车位数记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.batchBindsData.bindParkData.splice(index, 1)
      })
    },
    bindPark (fPark) {
      var bindPark = this.batchBindsData.bindParkData.filter(item => {
        return item.fParkID === fPark.fParkID
      })
      if (bindPark.length > 0) {
        bindPark[0].fPlaceNums = this.batchBindsData.fPlaceNums
      } else {
        this.batchBindsData.bindParkData.push({
          fPlaceNums: this.batchBindsData.fPlaceNums,
          fParkID: fPark.fParkID,
          fParkName: fPark.fParkName,
          fCustNo: fPark.fCustNo
        })
      }
    },
    addBindPark (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.batchBindsData.fParkID === '0') {
            for (let i = 1; i < this.batchBindsData.fParkList.length; i++) {
              this.bindPark(this.batchBindsData.fParkList[i])
            }
          } else {
            var fPark = this.batchBindsData.fParkList.filter(item => {
              return item.fParkID === this.batchBindsData.fParkID
            })
            this.bindPark(fPark[0])
          }
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save_msg = '保存中…'
          this.save_loading = true
          this.saveCardGroup(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.cardGroupEditOrDetailVisible = false
                this.initData()
                this.$message.success(data.Msg)
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    editCardGroup (index, row) {
      this.setDefault()
      this.detailTitle = ''
      if ((row.fCustName || '').length > 0) {
        this.detailTitle = '【' + row.fCustName + '】'
      }
      this.detailTitle += '编辑月卡分组：' + row.fGroupName
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.curRowInfo.op = 'edit'
      this.curRowInfo.isEdit = true
      this.curRowInfo.fIsSyn = this.cardGroupActiveName === 'synCardGroupList'
      this.cardGroupEditOrDetailVisible = true
    },
    deleteCardGroupClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteCardGroup({
          fBigRowID: row.fBigRowID,
          fIsSyn: this.cardGroupActiveName === 'synCardGroupList'
        }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    viewCardGroup (row) {
      this.setDefault()
      this.detailTitle = ''
      if ((row.fCustName || '').length > 0) {
        this.detailTitle = '【' + row.fCustName + '】'
      }
      this.detailTitle += '查看月卡分组：' + row.fGroupName
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.curRowInfo.isEdit = false
      this.cardGroupEditOrDetailVisible = true
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
    },
    addCardGroup () {
      this.setDefault()
      this.cardGroupEditOrDetailVisible = true
      this.curRowInfo.fGroupType = this.cardGroupTypeListDefaultValue
      this.curRowInfo.op = 'add'
      this.curRowInfo.fCardPlayVoc = ''// [p1]
      this.curRowInfo.fParkPort = '0'
      this.curRowInfo.isEdit = true
      this.detailTitle = '新增月卡分组'
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
    },
    syncAllCardGroup () {
      this.syncData.fCustID = ''
      this.synDataVisible = true
    },
    syncAllOk (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.syncData.fCustID) {
              return item
            }
          })
          var isSyn = this.cardGroupActiveName === 'synCardGroupList'
          var tip =
            '将客户[' +
            tmpCust[0].fCustName +
            ']的【分组列表】月卡分组，从云平台批量下发同步到线下客户端, 是否继续?'
          var synTip =
            '将客户[' +
            tmpCust[0].fCustName +
            ']的【待同步】月卡分组，从云平台批量下发同步到线下客户端, 是否继续?'
          this.$confirm(isSyn ? synTip : tip, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          })
            .then(() => {
              this.synCardGroupById({
                fCustID: this.syncData.fCustID,
                fIsSyn: isSyn
              }).then(res => {
                if (res && res.data) {
                  let { status, data } = res
                  if (status === 200) {
                    if (data.IsOk) {
                      this.$message({
                        type: 'success',
                        message: '操作完成'
                      })
                      this.synDataVisible = false
                    } else {
                      this.$message.error('提示：' + data.Msg)
                    }
                  }
                }
              })
            })
            .catch(() => { })
        }
      })
    },
    synCardGroup (index, row, isSyn) {
      if (row && row !== null && typeof row !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm(
          '将客户[' +
          row.fCustName +
          ']的月车分组[' +
          row.fGroupName +
          ']' +
          msg +
          ', 是否继续?',
          '提示',
          {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }
        )
          .then(() => {
            this.synCardGroupById({
              fBigRowID: row.fBigRowID,
              fIsSyn: isSyn
            }).then(res => {
              if (res && res.data) {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    this.$message({
                      type: 'success',
                      message: '操作完成'
                    })
                    this.initData()
                  } else {
                    this.$message.error(data.Msg)
                  }
                }
              }
            })
          })
          .catch(() => { })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    initData () {
      var isSyn = this.cardGroupActiveName === 'synCardGroupList'
      if (isSyn) {
        this.synCardGroupList = []
      } else {
        this.cardGroupList = []
      }
      this.loading = true
      this.getCardGroupByQuery({
        fCustID: this.selCustID,
        fGroupName: this.fGroupNameQuery,
        cardGroupActiveName: this.cardGroupActiveName,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (isSyn) {
                this.synCardGroupList = data.Data.rows
              } else {
                this.cardGroupList = data.Data.rows
              }
              this.total = data.Data.total
            }
          } else {
            this.$message.error('提示:' + data.Msg)
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 31000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_fDelIfInv = data.Data.data.is_fDelIfInv
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
            this.is_set = data.Data.data.is_set
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.timeRange = []
    for (var i = 0; i < 24; i++) {
      for (var j = 0; j < 12; j++) {
        var str =
          (i < 10 ? '0' + i : i) + ':' + (j * 5 < 10 ? '0' + j * 5 : j * 5)
        this.timeRange.push(str)
      }
    }
    this.timeRange.push('24:00')
    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            let tmpCusts = this.choiceCusts.filter(item => {
              if (item.fCustTypeID === '0') {
                return item
              }
            })
            Object.assign(this.batchCusts, tmpCusts)
          }
        }
      }
    })
    card.LoadCardGroupTypeList().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.cardGroupTypeListDefaultValue =
            data.Data.cardGroupTypeListDefaultValue
          this.cardGroupTypeList = data.Data.cardGroupTypeList
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
.myCardGroupEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myCardGroupEditOrDetail .el-dialog__title {
  color: white;
}
.myCardGroupEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myCardGroupEditOrDetail .el-dialog__body {
  padding: 5px;
}
#cardGroupMain .is-disabled .el-input__inner,
#cardGroupMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#cardGroupMain .warning-row {
  color: chocolate;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
#cardGroupMain .cardGroupForm {
  max-width: 500px;
  margin: 0px auto;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/card/cardGroupMain.vue